import Vue from 'vue'
import Element from 'element-ui'
import request from '@/utils/service'
import App from './App'

// 全局方法
import router from './router'
import store from './store'
import { resetForm } from './utils'

// 全局声明
import UploadImage from './components/upload/image'
import cusTable from './components/cus-table'

// 全局样式
import 'normalize.css'
import './styles/index.scss'
import './styles/variables.scss'

import './icons'
import './permission'

// 挂载过滤器
import * as filters from './filters'

Vue.component('upload-image', UploadImage)
Vue.component('cus-table', cusTable)

Vue.prototype.$resetForm = resetForm
Vue.prototype.$post = request

Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]))

Vue.use(Element)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
